
import { IKeHoachMonCopyByChuyenNganhRequest } from "../../../model/request/ke-hoach/IKeHoachMonCopyByChuyenNganhRequest";
import { IKeHoachMonFullPageActionTypes } from "../../action-types/ke-hoach/IKeHoachMonFullPageActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachMonFullPageReducer } from "../../reducer-model/ke-hoach/IKeHoachMonFullPageReducer";
const iniState: IKeHoachMonFullPageReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idKh: 0,
  keHoachMons: [],
  filter: {
    id_chuyen_nganh: 0,
    hoc_ky: 0,
    nam_hoc: "",
    id_he: 0,
    id_nganh: 0,
    khoa_hoc: 0,
  },
  addingMon: {
    isOpenModal: false,
    monHocSelectedIds: [],
    filter: {
      id_chuyen_nganh: 0,
      hoc_ky: 0,
      nam_hoc: "",
      id_he: 0,
      id_nganh: 0,
      khoa_hoc: 0,
    }
  },
  phanBoTiet: {
    status: eReducerStatusBase.is_not_initialization,
    data: []
  },
  keHoachMonSelectedIds: [],
  clipboardDataCopy: {
    status: eReducerStatusBase.is_not_initialization,
    data: {
      id_he: 0,
      khoa_hoc: 0,
      id_nganh: 0,
      id_chuyen_nganh: 0,
      nam_hoc: "",
      hoc_ky: 0,
      id_kh_mons: []
    }
  },

  isCapNhatSoKhoiTuDong: true
};
export const keHoachMonFullPageReducer = (
  state: IKeHoachMonFullPageReducer = iniState,
  action: IKeHoachMonFullPageActionTypes
): IKeHoachMonFullPageReducer => {
  switch (action.type) {
    case "KE_HOACH_MON_FULL_PAGE_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload,
        keHoachMonSelectedIds: []
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: action.payload,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_need_reload
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MON_SHOW_MODAL":
      return {
        ...state,
        addingMon: {
          ...state.addingMon,
          filter: {
            ...state.addingMon.filter,
            ...action.payload
          },
          isOpenModal: true
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MON_CLOSE_MODAL":
      return {
        ...state,
        addingMon: {
          ...state.addingMon,
          isOpenModal: false
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MON_CHANGE_SELECTED_IDs":

      return {
        ...state,
        addingMon: {
          ...state.addingMon,
          monHocSelectedIds: action.payload
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MONHOC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MONHOC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        addingMon: {
          ...state.addingMon,
          isOpenModal: false,
          monHocSelectedIds: []
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_ADDING_MONHOC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_FULL_PAGE_UPDATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_FULL_PAGE_UPDATE_SUCCESS":
      // const payloadMap = new Map(action.payload.map(item => [item.id_kh_mon, item]));
      const updatedKeHoachMons = [...state.keHoachMons];
      action.payload.forEach((newData) => {
        const id_kh_mon = newData.id_kh_mon;
        const index = updatedKeHoachMons.findIndex(s => s.id_kh_mon === id_kh_mon);
        if (index !== -1) {
          updatedKeHoachMons[index] = { ...updatedKeHoachMons[index], ...newData };
        }
      });
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: updatedKeHoachMons,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_need_reload
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_UPDATE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_PHANBOTIET_START":
      return {
        ...state,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_loading,
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_PHANBOTIET_SUCCESS":
      return {
        ...state,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_completed,
          data: action.payload
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_LOAD_PHANBOTIET_ERRR":
      return {
        ...state,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_completed,
        }
      }
    case "KE_HOACH_MON_FULL_PAGE_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_need_reload
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: state.keHoachMons.filter(x => !action.payload.ids.includes(x.id_kh_mon)),
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_need_reload
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        phanBoTiet: {
          ...state.phanBoTiet,
          status: eReducerStatusBase.is_need_reload
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_COPY_CLIPBOARD_DATA":
      return {
        ...state,
        clipboardDataCopy: {
          ...state.clipboardDataCopy,
          status: eReducerStatusBase.is_saving,
          data: action.payload as IKeHoachMonCopyByChuyenNganhRequest
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_PASTE_CLIPBOARD_DATA_START":
      return {
        ...state,
        clipboardDataCopy: {
          ...state.clipboardDataCopy,
          status: eReducerStatusBase.is_saving
        }
      };
    case "KE_HOACH_MON_FULL_PAGE_PASTE_CLIPBOARD_DATA_SUCCESS":
      return {
        ...state,
        clipboardDataCopy: {
          ...state.clipboardDataCopy,
          status: eReducerStatusBase.is_completed
        },
        status: eReducerStatusBase.is_need_reload
      };
    case "KE_HOACH_MON_FULL_PAGE_PASTE_CLIPBOARD_DATA_ERROR":
      return {
        ...state,
        clipboardDataCopy: {
          ...state.clipboardDataCopy,
          status: eReducerStatusBase.is_completed
        },
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_MON_FULL_PAGE_TACH_KHOI_GIANG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_FULL_PAGE_TACH_KHOI_GIANG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      }
    case "KE_HOACH_MON_FULL_PAGE_TACH_KHOI_GIANG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_FULL_PAGE_CHANGE_CAP_NHAT_SO_KHOI_TU_DONG_START":
      return {
        ...state,
        isCapNhatSoKhoiTuDong: action.payload
      }
   
    default:
      return state;
  }
};
